import UserInfo from './UserInfo';

export { UserInfo };
export default UserInfo;
